/* Initialize sticky sidebar */
export default function (fixed) {
  if ($(window).width() >= 1250) {
    if ($('.herald-sticky').length) {
      $('.herald-sidebar').each(function () {
        var $section = $(this).closest('.herald-section');
        var section_height;
        if ($section.find('.herald-ignore-sticky-height').length) {
          section_height = $section.height() - 40 - $section.find('.herald-ignore-sticky-height').height();
        } else {
          section_height = $section.height() - 40;
        }
        $(this).css('min-height', section_height);
      });

      //Fix for load more button if sticky is at bottom
      if (fixed && $(".herald-sticky").last().css('position') == 'absolute') {
        $(".herald-sticky").last().css('position', 'fixed').css('top', 100);
      }
      $(".herald-sticky").stick_in_parent({
        parent: ".herald-sidebar",
        offset_top: 100
      });
    }
  } else {
    $('.herald-sidebar').each(function () {
      $(this).css('height', 'auto');
      $(this).css('min-height', '1px');
    });
    $(".herald-sticky").trigger("sticky_kit:detach");
  }
}